export class CacheProvider {

    static defaultTtl = 1000 * 60 * 60 * 24; // 1 day

    static get<T>(key: string, version: number = 0): T | null {
        if (Office.context.partitionKey) {
            key = `${Office.context.partitionKey}.${key}`;
        }

        const item = localStorage.getItem(key);
        if (!item) {
            return null;
        }

        const cacheItem = JSON.parse(item) as CacheItem<T>;
        if (cacheItem.exp < Date.now() || cacheItem.ver < version) {
            localStorage.removeItem(key);
            return null;
        }

        return cacheItem.val;
    }

    static set<T>(key: string, value: T, version: number = 0, ttl: number = CacheProvider.defaultTtl) {
        if (Office.context.partitionKey) {
            key = `${Office.context.partitionKey}.${key}`;
        }

        const cacheItem = {
            val: value,
            ver: version,
            exp: Date.now() + ttl
        };

        localStorage.setItem(key, JSON.stringify(cacheItem));
    }

    static async getOrCreate<T>(key: string, valueFactory: () => Promise<T>, version: number = 0, ttl: number = CacheProvider.defaultTtl): Promise<T> {
        let value = this.get<T>(key, version);

        if (!value) {
            value = await valueFactory();
            CacheProvider.set(key, value, version, ttl);
        }

        return value;
    }

    static clear() {
        localStorage.clear();
    }
}

export interface CacheItem<T> {
    val: T
    ver: number
    exp: number
}